import { render, staticRenderFns } from "./MoleculeChoosePhases.vue?vue&type=template&id=09b60ee0&"
import script from "./MoleculeChoosePhases.vue?vue&type=script&lang=js&"
export * from "./MoleculeChoosePhases.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeChoosePhases.vue?vue&type=style&index=0&id=09b60ee0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculeChoosePhases.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fproject%2FbuildingV2%2FMoleculeChoosePhases.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports